import React from 'react';

import WoWArenaRankPicker from './wowArena/WoWArenaRankPicker';
import WoWArenaRankPicker2400 from "./wowArena/WowArenaRankPicker2400";
import WoWBattlegroundPicker from './wowBattleground/WoWBattlegroundPicker';
import WoWLevelingRankPicker from './wowLeveling/WoWLevelingRankPicker';
// import WoWLevelingBFARankPicker from './wowLevelingBFA/WoWLevelingBFARankPicker';
import WoWLevelingClassicRankPicker from './wowLevelingClassic/WoWLevelingClassicRankPicker';
import SodLeveling1To50 from './sodLeveling/Leveling1to50';
import SodLevelingRankPicker1to60 from './sodLeveling/Leveling1to60';
import CataclysmLeveling1to85 from './wowLevelingClassic/CataclysmLeveling1to85';
import PandariaProfessionLeveling1to600RankPicker from './wowLevelingPandaria/PandariaProfessionLeveling1to600RankPicker'
import Pandaria1to90RankPicker from './wowLevelingPandaria/Pandaria1to90RankPicker'
import Pandaria1to90And85to90defaultRankPicker from './wowLevelingPandaria/Pandaria1to90And85to90defaultRankPicker'
import Midnight1to90RankPicker from './wowLevelingMidnight/Midnight1to90RankPicker'
import RemixLeveling10to70 from './wowLevelingClassic/RemixLeveling10to70';
import MobileLegendsRankPicker from './mobileLegends/MobileLegendsRankPicker';
import MobileLegendsRankPicker1to250 from './mobileLegends/MobileLegendsRankPicker1to250';
import FlexibleRankCalculator from './flexibleRankPicker/FlexibleRankPicker';
import ApexLegendsRankPicker from './apexLegends/ApexLegendsRankPicker';
import Diablo4LevelingRankPicker from './diablo4Leveling/Diablo4Leveling';
import Diablo4LordOfHatredLevelingRankPicker from './diablo4Leveling/Diablo4LordOfHatredLeveling';
import Diablo4SeasonOfDiscoveryLevelingRankPicker from './diablo4Leveling/Diablo4SeasonOfDiscoveryLeveling';
import Leveling1To40 from './levelingRankPicker/Leveling1to40';
import Leveling1to55 from './levelingRankPicker/Leveling1to55';
import Leveling1To60Hardcore from './levelingRankPicker/Leveling1To60Hardcore';
import Leveling1to65 from './levelingRankPicker/Leveling1to65';
import Leveling1To70 from './levelingRankPicker/Leveling1To70';
import Leveling1To80 from './levelingRankPicker/Leveling1To80';
import Leveling1To300 from './levelingRankPicker/Leveling1to300';
import Leveling1to1000 from './levelingRankPicker/Leveling1to1000';
import Destiny2PowerLevelPicker from './destiny2/Destiny2PowerLevel';
import Destiny2IronBannerRankPicker from './destiny2/Destiny2IronBannerRank';
import NWGearScore725 from './newWorldLeveling/NWGearScore725';
import AnniversaryTier2SetsRankPicker from './AnniversaryTier2SetsRankPicker/AnniversaryTier2SetsRankPicker';
import CodLeveling1to15000RankPicker from './cod/CodLeveling1to15000RankPicker';
import CodLeveling1to18000RankPicker from './cod/CodLeveling1to18000RankPicker';
import MarvelRivals0to2100RankPicker from './marvelRivals/MarvelRivals0to2100RankPicker';
import TlLeveling1To55RankPicker from './tl/TlLeveling1To55RankPicker';
import PoE2Leveling1To100RankPicker from './poe2/PoE2Leveling1To100RankPicker';
import LastEpoch1To10RankPicker from './lastEpoch/LastEpoch1To10RankPicker';
import LastEpoch1To12RankPicker from './lastEpoch/LastEpoch1To12RankPicker';

export default function RankPickerContainer({calculator, value, onChange}) {
  const RankPickerComponent = RankPickerContainer.componentByType[calculator.displayType];

  if (!RankPickerComponent) {
    return null;
  }

  return (
    <RankPickerComponent
      value={value}
      onChange={onChange}
      min={calculator.ranges[0].start}
      max={calculator.ranges[calculator.ranges.length - 1].end}
    />
  );
}

RankPickerContainer.componentByType = {
  anniversary_tier_2_set: AnniversaryTier2SetsRankPicker,
  ml: MobileLegendsRankPicker,
  wow_arena: WoWArenaRankPicker,
  'wow_arena_0-2400': WoWArenaRankPicker2400,
  wow_battleground: WoWBattlegroundPicker,
  wow_leveling: WoWLevelingRankPicker,
  // FIXME: we are using wow_leveling_bfa here as a testing placeholder for apex
  // legends ranked calculator as it is not used anywhere for the time being,
  // replace with actual apex legends calculator when backend/admin will be updated.
  // wow_leveling_bfa: WoWLevelingBFARankPicker,
  wow_leveling_bfa: ApexLegendsRankPicker,
  wow_leveling_classic: WoWLevelingClassicRankPicker,
  diablo4_leveling: Diablo4LevelingRankPicker,
  diablo4_lord_of_hatred_leveling: Diablo4LordOfHatredLevelingRankPicker,
  'sod_leveling_1-40': Leveling1To40,
  'sod_leveling_1-50': SodLeveling1To50,
  'sod_leveling_1-60': SodLevelingRankPicker1to60,
  season_of_discovery_leveling: Diablo4SeasonOfDiscoveryLevelingRankPicker,
  'cataclysm_leveling_1-85': CataclysmLeveling1to85,
  'pandaria_profession_leveling_1-600': PandariaProfessionLeveling1to600RankPicker,
  'pandaria_1-90': Pandaria1to90RankPicker,
  'pandaria_1-90_85-90_default': Pandaria1to90And85to90defaultRankPicker,
  'midnight_1-90': Midnight1to90RankPicker,
  flexible: FlexibleRankCalculator,
  'leveling_1-55': Leveling1to55,
  'leveling_1-60_hardcode': Leveling1To60Hardcore,
  'leveling_1-65': Leveling1to65,
  'leveling_1-70': Leveling1To70,
  'leveling_1-80': Leveling1To80,
  'leveling_1-300': Leveling1To300,
  'leveling_1-1000': Leveling1to1000,
  'nw_gear_score_725': NWGearScore725,
  'mobile_legends_mythic_stars_1-250': MobileLegendsRankPicker1to250,
  'wow_remix_leveling': RemixLeveling10to70,
  'destiny2_power_level': Destiny2PowerLevelPicker,
  'destiny2_iron_banner_rank': Destiny2IronBannerRankPicker,
  'cod_ranked_play_1-15000': CodLeveling1to15000RankPicker,
  'cod_ranked_play_1-18000': CodLeveling1to18000RankPicker,
  'marvel_rivals_0-2100': MarvelRivals0to2100RankPicker,
  'tl_leveling_1-55': TlLeveling1To55RankPicker,
  'poe2_leveling_1-100': PoE2Leveling1To100RankPicker,
  'last_epoch_1-10': LastEpoch1To10RankPicker,
  'last_epoch_1-12': LastEpoch1To12RankPicker,
};

RankPickerContainer.describeRank = (value, calculator) => {
  const RankPickerComponent = RankPickerContainer.componentByType[calculator.displayType];

  if (!RankPickerComponent) {
    return '';
  }

  return RankPickerComponent.describeRank(value, {min: calculator.ranges[0].start});
};

RankPickerContainer.getDefaultValue = (calculator) => {
  const RankPickerComponent = RankPickerContainer.componentByType[calculator.displayType];

  if (!RankPickerComponent || !RankPickerComponent.getDefaultValue) {
    return [calculator.ranges[0].start, calculator.ranges[0].end];
  }

  return RankPickerComponent.getDefaultValue({min: calculator.ranges[0].start});
};



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/RankPickerContainer.js